import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a40b66cca334e0014702c99_1785507148334_72b37aad/tugarecruitment/src/app/page.tsx");
